import React from "react";
import { DeviceListLoaderTemplate } from "../../../../themes/default/administration/device-menu/components";

function DeviceListLoader(props) {
    return <DeviceListLoaderTemplate {...props} />;
}

export default DeviceListLoader;
